import {AirtableFeedItem} from '../../models/airtable';

import {FeedDiscoverPage, PaginatedFeedResponse, UseFeedListResult} from './types';

const todayISO = (): string => {
  const d = new Date();
  return `${d.getFullYear()}-${(d.getMonth() + 1).toString().padStart(2, '0')}-${d
    .getDate()
    .toString()
    .padStart(2, '0')}`;
};

const inFeedWindow = (item: AirtableFeedItem, today: string) => {
  if (!item.start || !item.end) return false;
  return item.start <= today && item.end >= today;
};

const inDiscoverWindow = (item: AirtableFeedItem, today: string) => {
  const isNotExpired = item.postEnd ? item.postEnd >= today : true;
  return item.postStart <= today && isNotExpired;
};

/**
 * Splits a flat AirtableFeedItem[] into the three buckets the Home feed needs.
 * Extracted from the previous inline `feedListQueryFn` body so the paginated
 * discover path can reuse the same date predicates.
 */
export const filterByDatesFlat = (
  data: AirtableFeedItem[] | undefined,
  today: string = todayISO(),
): UseFeedListResult => {
  const items = data ?? [];
  const feedList = items.filter(item => inFeedWindow(item, today));
  const discoverList = items.filter(item => inDiscoverWindow(item, today));
  const allItems = items;
  return {feedList, discoverList, allItems};
};

/**
 * Per-page variant for `useInfiniteQuery`. Filters items via the post-window
 * predicate and preserves the envelope pagination metadata so
 * `getNextPageParam` can read `offset`/`limit`/`hasMore` off the page.
 */
export const filterByDatesPage = (
  envelope: PaginatedFeedResponse<AirtableFeedItem>,
  today: string = todayISO(),
): FeedDiscoverPage => {
  const items = envelope.items ?? [];
  const discoverList = items.filter(item => inDiscoverWindow(item, today));
  return {
    items,
    discoverList,
    offset: envelope.offset,
    limit: envelope.limit,
    hasMore: envelope.hasMore,
    total: envelope.total,
  };
};
